import { render, staticRenderFns } from "./WhatsAppLink.vue?vue&type=template&id=2dc5de56&scoped=true"
import script from "./WhatsAppLink.vue?vue&type=script&lang=js"
export * from "./WhatsAppLink.vue?vue&type=script&lang=js"
import style0 from "./WhatsAppLink.vue?vue&type=style&index=0&id=2dc5de56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc5de56",
  null
  
)

export default component.exports